import React, { useState,useEffect } from "react";
import { Box, MenuItem, Select, FormControl, InputLabel, Popover, Button,Typography,useTheme,useMediaQuery } from "@mui/material";
import { DateRange } from "react-date-range";
import { addDays,format } from "date-fns";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import SingleDatePicker from "./SingleDatePicker";
import InviteeTable from "./InviteeTable";
import { useTranslation } from "react-i18next";

const InviteeList = () => {
  const [recordType, setRecordType] = useState("all");
    const theme = useTheme();
    const mobileView = useMediaQuery(theme.breakpoints.down("sm"));
    const [anchorElStart, setAnchorElStart] = useState(null);
    const [anchorElEnd, setAnchorElEnd] = useState(null);
    const [status, setStatus] = useState("all");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const { t } = useTranslation();
     const isLightTheme = process.env.REACT_APP_IS_LIGHT_THEME === "true";

  // Date range state (default to 1 week ago to today)
  const [dateRange, setDateRange] = useState([
    {
      startDate: addDays(new Date(), -7),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  // Popover state
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpenDate = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseDate = () => {
    setAnchorEl(null);
  };

  const [queryParams, setQueryParams] = useState({
      status: status,
      startDate: null,
      endDate: null,
  });

useEffect(() => {
  const today = new Date();
  let newStartDate = today;

  setStartDate(newStartDate);
  setEndDate(today);
}, []);

  useEffect(() => {
  
    if (startDate && endDate) {
      submitDateQuery(startDate, endDate);
    }
  
  }, [startDate, endDate]);

const submitDateQuery = (start, end) => {
  const formattedStartDate = start ? format(start, 'yyyy-MM-dd') : null;
  const formattedEndDate = end ? format(end, 'yyyy-MM-dd') : null;

  setQueryParams({
    startDate: formattedStartDate,
    endDate: formattedEndDate,
  });

  // console.log("Submitting with dates:", {
  //   startDate: formattedStartDate,
  //   endDate: formattedEndDate
  // });
};

const handleManualSubmit = () => {
  submitDateQuery(startDate, endDate);
};

  const open = Boolean(anchorEl);
  const id = open ? "date-range-popover" : undefined;

  const formatDate = (date) =>
    date.toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" });

   return (
        <>
          {mobileView ? (
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              flexWrap="wrap"
              gap={2}
              sx={{ mb: 2 }}
            >
              {/* Record Type Dropdown */}
              {/* <FormControl sx={{ minWidth: 200, flex: 1, maxWidth: 250 }}>
                <InputLabel id="record-type-label">{t("referral.status")}</InputLabel>
                <Select
                  labelId="record-type-label"
                  value={recordType}
                  label="Record Type"
                  onChange={(e) => setRecordType(e.target.value)}
                  size="small"
                >
                  <MenuItem value="referral">{t("referral.statusall")}</MenuItem>
                  <MenuItem value="achievement">{t("referral.qualified")}</MenuItem>
                  <MenuItem value="commission">{t("referral.notqualified")}</MenuItem>
                </Select>
              </FormControl> */}

              {/* Date Range Button */}
              <Box sx={{ flex: 1, maxWidth: '100%' }}>
                <Button
                  variant="outlined"
                  onClick={handleOpenDate}
                  size="small"
                  fullWidth
                  sx={{ textTransform: "none" ,color:isLightTheme?"black":"white", borderColor: isLightTheme ? "black" : "white",}}
                >
                  {`${formatDate(dateRange[0].startDate)} - ${formatDate(dateRange[0].endDate)}`}
                </Button>
                <Popover
                  id={id}
                  open={open}
                  anchorEl={anchorEl}
                  onClose={handleCloseDate}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                >
                  <DateRange
                    editableDateInputs={true}
                    onChange={(item) => setDateRange([item.selection])}
                    moveRangeOnFirstSelection={false}
                    ranges={dateRange}
                  />
                </Popover>
              </Box>
            </Box>
          ) : (
      <Box px={4} py={2} mt={5}>
          <Box display="flex" flexDirection="column" gap={2} mb={4}>
          
            {/* Row 3: Status */}
            {/* <Box display="flex" alignItems="center" gap={2}>
              <Box sx={{ width: 150 }}>
                <Typography sx={{ color: isLightTheme ? "black" : "white" }}>{t("referral.status")}:</Typography>
              </Box>
              <FormControl size="small" sx={{ minWidth: 200 }}>
                <InputLabel>{t("referral.status")}</InputLabel>
                <Select
                  value={status}
                  label="Status"
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <MenuItem value="all">{t("referral.statusall")}</MenuItem>
                  <MenuItem value="pending">{t("referral.statuspending")}</MenuItem>
                  <MenuItem value="completed">{t("referral.statuscompleted")}</MenuItem>
                </Select>
              </FormControl>
            </Box> */}

            {/* Row 4: Date Range */}
            <Box display="flex" alignItems="center" gap={2}>
              <Box sx={{ width: 150 }}>
                <Typography sx={{ color:isLightTheme?"black":"white" }}>{t("referral.daterange")}:</Typography>
              </Box>
              <SingleDatePicker
                label=""
                selectedDate={startDate}
                setSelectedDate={setStartDate}
                anchorEl={anchorElStart}
                setAnchorEl={setAnchorElStart}
              />

              <Typography sx={{ color:isLightTheme?"black":"white" }}>to</Typography>

              <SingleDatePicker
                label=""
                selectedDate={endDate}
                setSelectedDate={setEndDate}
                anchorEl={anchorElEnd}
                setAnchorEl={setAnchorElEnd}
              />
              <Button variant="contained" size="small" onClick={handleManualSubmit}>
                {t("referral.submit")}
              </Button>
            </Box>
          </Box>

            {/* Bottom Data Table Section */}
            <Box mt={4}>
              <InviteeTable
              startDate={queryParams.startDate}
              endDate={queryParams.endDate}
              >
              </InviteeTable>
            </Box>
          </Box>
            
          )}
        </>
      );
};

export default InviteeList;
